<div class="main-notification hidden" #notification>
  <a class="close-link" (click)="removeNotification()">Close</a>
  {{notificationMessage}}
</div>
